<template>
    <b-btn 
        class="loader-button" 
        v-bind="$attrs" 
        @click="$emit('click')" 
        :disabled="loading"
        :style="$slots.default || 'justify-content: center;'"
    >
        <slot />

        <loader class="loader-button-loader" v-if="loading"/>

        <fa-icon :icon="iconName" v-else-if="iconName" />

    </b-btn>
</template>

<script>
import Loader from '../Loader';
import { isEmpty } from 'lodash';

export default {
    components: {
        Loader
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },

        iconName: {
            type: String,
            default: 'download'
        }
    },
    data: () => ({
    }),
    computed: {},
    methods: {},
    mounted () {
        console.log(this.$slots.default);
    }
}
</script>

<style lang="scss">
.loader-button {
    min-width: 3.125rem;
    display: flex !important;
    align-items: center;
    justify-content: space-between;

    &-loader {
        display: inline-block;
    }
}
</style>


// WEBPACK FOOTER //
// LoaderButton.vue?b3dc1bc2